import { AzaleaLegalDoc } from './AzaleaLegalDoc';
import { LEGAL_DOCUMENTS } from './legalContent';

export function AzaleaPrivacy() {
  return <AzaleaLegalDoc doc={LEGAL_DOCUMENTS.privacy} />;
}

export function AzaleaTerms() {
  return <AzaleaLegalDoc doc={LEGAL_DOCUMENTS.terms} />;
}

export function AzaleaFaq() {
  return <AzaleaLegalDoc doc={LEGAL_DOCUMENTS.faq} />;
}

export function AzaleaSupport() {
  return <AzaleaLegalDoc doc={LEGAL_DOCUMENTS.support} />;
}

export function AzaleaDataRights() {
  return <AzaleaLegalDoc doc={LEGAL_DOCUMENTS.dataRights} />;
}
